import { Typography } from 'app/components';
import Spinner from 'app/components/Spinner';
import { i18n } from 'app/utils/i18n';
import { useDocumentTaxonomyConfig } from 'app/api/tag-queries/document-taxonomy-config';
import { usePresentationTree } from 'app/api/tag-queries/taxonomy';
import { CategoryOverridesSection } from './CategoryOverridesSection';

interface CategoriesProps {
  documentId: string;
}

export const Categories = ({ documentId }: CategoriesProps) => {
  const documentSuperId = documentId ? parseInt(documentId, 10) : undefined;
  const { data: config, isLoading: isConfigLoading } = useDocumentTaxonomyConfig(documentSuperId);
  const { data: presentation, isLoading: isPresentationLoading } = usePresentationTree(documentSuperId);

  if (isConfigLoading || isPresentationLoading) {
    return (
      <div className="tagging-settings">
        <div className="text-center py-4">
          <Spinner />
          <Typography variant="body-7">{i18n('tag.taxonomy.settings.loading')}</Typography>
        </div>
      </div>
    );
  }

  if (!config) {
    return (
      <div className="tagging-settings">
        <Typography variant="body-7">{i18n('tag.categories.noConfig') || 'No taxonomy configuration on this document yet.'}</Typography>
      </div>
    );
  }

  const activeTaxonomyId = config.taxonomySelections?.find((t) => t.isActive)?.taxonomyId;
  const networks = presentation?.presentationTree?.networks ?? [];

  if (!activeTaxonomyId) {
    return (
      <div className="tagging-settings">
        <Typography variant="body-7">{i18n('tag.categories.noActiveTaxonomy') || 'No active taxonomy selected.'}</Typography>
      </div>
    );
  }

  if (networks.length === 0) {
    return (
      <div className="tagging-settings">
        <Typography variant="body-7">{i18n('tag.categories.noCategories') || 'The active taxonomy exposes no top-level categories.'}</Typography>
      </div>
    );
  }

  return (
    <div className="tagging-settings">
      <CategoryOverridesSection
        configId={config.id}
        activeTaxonomyId={activeTaxonomyId}
        networks={networks}
        overrides={config.taxonomyOverrides ?? {}}
        canEdit={true}
      />
    </div>
  );
};
